import React from 'react';
import { motion } from 'framer-motion';
const volumes = [{
  num: 1,
  title: 'Moldes Básicos para Empezar',
  desc: 'Patrones amigables para principiantes. Empezá hoy mismo.',
  price: '7.500'
}, {
  num: 2,
  title: 'Vestidos y Moda Elegante',
  desc: 'Vestidos bonitos y conjuntos elegantes para tu mascota.',
  price: '7.500'
}, {
  num: 3,
  title: 'Ropa de Invierno',
  desc: 'Sudaderas, suéteres y abrigos cálidos.',
  price: '7.500'
}, {
  num: 4,
  title: 'Accesorios y Complementos',
  desc: 'Bandanas, moños, gorritos y más detalles.',
  price: '7.500'
}, {
  num: 5,
  title: 'Moldes Premium Profesionales',
  desc: 'Diseños avanzados y piezas de tendencia.',
  price: '7.500'
}, {
  num: 6,
  title: 'Emprendimiento Pet',
  desc: 'Cómo empezar a vender ropa para mascotas desde casa.',
  price: '7.500'
}];
export function Volumes() {
  return <section id="tomos" className="py-20 bg-brand-cream-light overflow-hidden" data-id="element-249">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-250">
        <div className="text-center mb-10" data-id="element-251">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-252">
            Tu biblioteca completa de{' '}
            <span className="text-brand-rose" data-id="element-253">6 tomos premium</span>
          </h2>
          <p className="text-lg text-brand-brown/80 mb-6" data-id="element-254">
            Cada tomo, un universo de diseños para tu mascota.
          </p>

          {/* Eye-catching price callout */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-3 bg-gradient-to-r from-brand-pink-light via-white to-brand-pink-light px-6 py-3 rounded-full shadow-soft-pink border border-brand-pink-mid" data-id="element-255">
            <span className="text-xl" data-id="element-256">💕</span>
            <span className="font-medium text-brand-brown text-base md:text-lg" data-id="element-257">
              Por hoy te lo llevás a{' '}
              <span className="font-bold text-brand-rose text-xl md:text-2xl" data-id="element-258">
                $19.990
              </span>
            </span>
            <span className="text-xl" data-id="element-259">💕</span>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6" data-id="element-260">
          {volumes.map((vol, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.08
        }} className="flex flex-col items-center text-center group" data-id="element-261">
              {/* Faux 3D Book Cover - smaller */}
              <div className="relative w-full aspect-[3/4] mb-3" data-id="element-262">
                <div className="w-full h-full relative shadow-xl rounded-r-md rounded-l-sm bg-gradient-to-br from-brand-pink-light to-brand-pink-dark border-l-2 border-white/40 flex flex-col items-center justify-center p-2 text-brand-brown group-hover:scale-105 transition-transform duration-300" data-id="element-263">
                  <div className="absolute left-0 top-0 bottom-0 w-2 bg-gradient-to-r from-black/20 to-transparent rounded-l-sm" data-id="element-264"></div>

                  <span className="font-script text-2xl text-brand-rose opacity-80 leading-none" data-id="element-265">
                    Tomo
                  </span>
                  <span className="font-serif text-4xl font-bold leading-none mb-2" data-id="element-266">
                    {vol.num}
                  </span>
                  <div className="w-6 h-0.5 bg-brand-brown/20 mb-2" data-id="element-267"></div>
                  <span className="font-sans text-[0.6rem] font-bold uppercase tracking-wider text-center leading-tight px-1" data-id="element-268">
                    {vol.title.split(' ').slice(0, 3).join(' ')}
                  </span>
                </div>
              </div>

              <div className="bg-white px-2 py-0.5 rounded-full text-[0.65rem] font-bold text-brand-rose mb-1.5 shadow-sm" data-id="element-269">
                TOMO {vol.num}
              </div>
              <h3 className="text-sm font-bold mb-1 leading-tight" data-id="element-270">
                {vol.title}
              </h3>
              <p className="text-brand-brown/70 text-xs leading-snug mb-2 hidden md:block" data-id="element-271">
                {vol.desc}
              </p>

              {/* Price */}
              <div className="mt-auto pt-1" data-id="element-272">
                <span className="inline-block bg-brand-pink-light/60 text-brand-rose font-bold text-sm px-3 py-1 rounded-full" data-id="element-273">
                  ${vol.price}
                </span>
              </div>
            </motion.div>)}
        </div>

        {/* Total */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center" data-id="element-274">
          <p className="text-brand-brown/70 text-base mb-1" data-id="element-275">
            Valor real del paquete completo:
          </p>
          <p className="text-3xl md:text-4xl font-bold text-brand-brown" data-id="element-276">
            <span className="line-through text-brand-brown/50" data-id="element-277">$45.000</span>
          </p>
        </motion.div>
      </div>
    </section>;
}